module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'projectTermJobApplications',
        // showHead: true,
        showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        // rowActionsProperties: {
        //     colWidth: '105px',
        // },
        rowActions: {
            // edit: true,
            // customs: [
            //     {
            //         buttonType: 'advertise',
            //     },
            //     {
            //         buttonType: 'delete',
            //         neutral: true,
            //     }
            // ]
        },
        addRowClassViaAttribute: {
            fieldCode:  'status',
            value:      null,
            class:      'statusIsEmpty',
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_projectTermJobStatus': true,
            'resourceChanged.bo_projectTermJobs': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'status',
                direction: 'desc'
            },{
                fieldCode: 'ts',
                direction: 'asc'
            },{
                fieldCode: 'type',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const baseFilters = (this.model.parentEntityForTable || {}).baseFilters || {}

            if(refreshers[key] && (
                (
                    key !== 'resourceChanged.bo_projectTermJobs' &&
                    key !== 'resourceChanged.bo_projectTermJobStatus'
                ) ||
                (key === 'resourceChanged.bo_projectTermJobs' && (message.data.projectTermJobID == baseFilters.projectTermJobID || message.data.primaryKey == baseFilters.projectTermJobID || (message.data.primaryKeys || {})[baseFilters.projectTermJobID])) ||
                (key === 'resourceChanged.bo_projectTermJobStatus' && (message.data.projectTermJobID == baseFilters.projectTermJobID || (message.data.projectTermJobIDs || {})[baseFilters.projectTermJobID]))
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    }
}